import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { KnowledgeUsagedTypes } from 'services/accountConversations/types';
import { SocketStatus } from 'utils/socket';

type WSData = {
  payload: WSPayload;
  type: string;
};

interface PayloadData<T> {
  data: T;
}

type WSPayload = {
  metadata: WSMetadata;
  tokens?: string;
  items?: Array<KnowledgeUsagedTypes>;
  currentUuid?: string;
  answer: string;
};

type WSMetadata = {
  uuid: string;
};

interface SocketState {
  currentUuid: string;
  data: WSData[];
  socketStatus: string;
  token: string;
}

const initialState: SocketState = {
  currentUuid: '',
  data: [],
  socketStatus: SocketStatus.DISCONNECTED,
  token: ''
};

export const socketSlice = createSlice({
  name: 'socketReducer',
  initialState,
  reducers: {
    setCurrentUuid: ($state, action: PayloadAction<PayloadData<string>>) => {
      const { data } = action.payload;
      $state.currentUuid = data;
    },
    receiveData: ($state, action: PayloadAction<WSData>) => {
      const data = action.payload;
      if (data?.payload?.metadata.uuid === $state.currentUuid) {
        const temp = [...$state.data];
        $state.data = [...temp, data];
      }
    },
    resetData: ($state) => {
      $state.data = [];
    },
    setSocketStatus: ($state, action: PayloadAction<string>) => {
      $state.socketStatus = action.payload;
    },
    setCurrentChatbotAccessToken: ($state, action: PayloadAction<PayloadData<string>>) => {
      const { data } = action.payload;
      $state.token = data;
    },
  },
  extraReducers() {},
});

export default socketSlice.reducer;
export const {
  setCurrentUuid, receiveData, resetData, setSocketStatus, setCurrentChatbotAccessToken
} = socketSlice.actions;
